import React from "react";
import PropTypes from "prop-types";

import { OrderObject, CurrentUserObject } from "../Queries/OrderQuery";
import ShipmentsDropdown from "./ShipmentsDropdown";

class ResendShipmentsDropdown extends React.Component {
  render() {
    return (
      <ShipmentsDropdown
        {...this.props}
        showCreateOption={false}
      />
    );
  }
}

ResendShipmentsDropdown.propTypes = {
  order: OrderObject.isRequired,
  currentUser: CurrentUserObject.isRequired
};

export default ResendShipmentsDropdown; 